import { useEffect, useState } from "react"
import { PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { BillingUserInfoType } from "@/types/billing"
import { canViewThisPage } from "@/lib/api/auth"
import { getBillingUserInfo } from "@/lib/api/billing"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { billingUserInfoColumns } from "@/components/table/columns/billing-user-info-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import { AddBillingUserInfoPage } from "./add"

export const Route = createFileRoute(
  "/_home/user-role-management/billing-user-info/",
)({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_billinguserinfo")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: BillingUserInfo,
})

function BillingUserInfo() {
  const [showExportModal, setShowExportModal] = useState<boolean>(false)
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")

  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)
  const {
    data: billingUserInfoDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<BillingUserInfoType>>({
    queryKey: ["billingUserInfoDetails", defaultPage, page, search],
    queryFn: () => getBillingUserInfo(defaultPage, page, search),
  })

  useEffect(() => {
    if (billingUserInfoDetails) {
      setNextPageUrl(billingUserInfoDetails.next)
      setPrevPageUrl(billingUserInfoDetails.previous)
    }
  }, [billingUserInfoDetails])

  return (
    <main className="space-y-4 p-4">
      <Header>Billing User Info</Header>
      <DataTable
        columns={billingUserInfoColumns}
        data={billingUserInfoDetails?.results ?? []}
        search={{
          field: "username",
          label: "username",
          //value: search,
          //onChange: setSearch,
        }}
        isLoading={isLoading}
        isError={isError}
        defaultPage={defaultPage}
        setDefaultPage={setDefaultPage}
        nextPageUrl={nextPageUrl}
        prevPageUrl={prevPageUrl}
        page={page}
        setPage={setPage}
        totalCount={billingUserInfoDetails?.count}
      >
        <div className="flex w-full justify-end gap-2">
          <AddBillingUserInfoPage />
          <ExportOperationModal
            tableData={billingUserInfoDetails?.results ?? [{}]}
            fileName="Billing User Info"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </div>
      </DataTable>
    </main>
  )
}
